import { createSlice } from '@reduxjs/toolkit'
import {
  CONTENT_TYPE,
  DASHBOARD_TABS,
  DASHBOARD_MESSAGES
} from 'shared-ui/utils/constants'

const initialState = {
  userDashBoardContentType: CONTENT_TYPE.VIDEO,
  contentDashBoardContentType: CONTENT_TYPE.VIDEO,
  contentDashboardPusblishedType: DASHBOARD_TABS.PUBLISHED || "Published",
  filters: {
    sortBy: 'newest_first',
    contentTypes: ['video', 'image', 'audio'],
    tools: []
  }
}

const dashBoardSelectedTypeSlice = createSlice({
  name: 'dashBoardSelectedType',
  initialState,
  reducers: {
    updatedDashBoardSelectedType: (state, action) => {
      Object.assign(state, action.payload)
    },
    resetDashBoardSelectedType: () => initialState
  }
})

export const { updatedDashBoardSelectedType, resetDashBoardSelectedType } =
  dashBoardSelectedTypeSlice.actions
export default dashBoardSelectedTypeSlice.reducer
